import React, { forwardRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { Select, Spin } from "antd";
import debounce from "lodash/debounce";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { LabelPadrao, } from "../Base";
import { useCadastro } from "../../containers/Cadastros/Base/useCadastro";
import FullScreenDialog from "../DialogPadrao";
import ClienteDetalhe from "./../../containers/Cadastros/ClienteDetalhe";
import { BtnAdd, BtnLink } from "../Buttons";
import Mensagens from "../Mensagens";
import handleTabIndex from "../../Utils/HandleTabIndex";

const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const SelectPesq = forwardRef(({ value, onChange, onOk, modelo, multi, showEdit, showAdd, title, noMargin, maxTagTextLength, ...props }, ref) => {
  const [data, setData] = useState([]);
  const [idCadastro, setIdCadastro] = useState(null);
  const [loading, setLoading] = useState(false);

  function listar(valor, enterClicked) {
    setLoading(true);

    props.fetch().post(`/${modelo}/getlist`, { txt: valor })
      .then(response => {
        if (enterClicked && response.data && response.data?.length === 1 && !multi)
          onChangeInternal(response.data);
        else if (!enterClicked)
          setData(response.data);

        setLoading(false);
      })
      .catch(err => { Mensagens.showErro(err); setLoading(false); });
  }

  function saved(savedData) {
    setIdCadastro(null);
    onChange([{ ...savedData, label: `${!!savedData.codigo.length ? `${savedData.codigo} - ` : ""}${savedData.nome}` }]);

    if (!!onOk)
      onOk(savedData);
  }

  function onChangeInternal(valor) {
    var aux = valor;

    if (!!valor?.length && !multi) {
      aux = [valor[valor.length - 1]];

      var ret = aux.map(x => {
        var val = data?.find(s => s.id == Number(x.key));
        if (!val)
          val = valor[valor.length - 1];

        return { ...val, label: x.label ? x.label : `${!!val.codigo.length ? `${val.codigo} - ` : ""}${val.nome}` };
      });

      onChange(ret);

      setData([]);

      proximoTab();
    }
    else
      onChange(aux);
  };

  const proximoTab = () => handleTabIndex(props.tabIndex, props.nextTab);

  return <>
    <div style={{ position: "relative" }}>
      {!!title && <LabelPadrao noMargin={noMargin}>{title}</LabelPadrao>}
      {!!showEdit && !!value && value.length == 1 && <BtnLink style={{ position: "absolute", top: -10, right: 50 }} type="link" onClick={() => setIdCadastro(value[0].key)}>Editar</BtnLink>}
    </div>
    <div style={{ display: "flex" }}>
      <Select
        suffixIcon={<SearchOutlined />}
        ref={ref}
        mode="multiple"
        labelInValue
        id="select-pesq"
        maxTagTextLength={maxTagTextLength ? maxTagTextLength : 35}
        notFoundContent={loading ? <Spin indicator={antIcon} size="small" /> : null}
        filterOption={false}
        value={value}
        {...props}
        onBlur={e => {
          setData([]);
          if (!!props?.onBlur)
            props?.onBlur(e);
        }}
        onChange={onChangeInternal}
        defaultOpen={!multi && data.length}
        onSearch={debounce(listar, 800)}
        onKeyDown={e => {
          if (e.keyCode === 13 && !e.target.value?.length)
            proximoTab();

        }}
        onInputKeyDown={debounce(e => {
          if (e.keyCode === 13 && !!e.target.value?.length)
            listar(e.target.value, true);
        }, 800)}
        style={{ width: "100%", ...props.style }}
        dropdownMenuStyle={{ maxHeight: "50vh", ...props.dropdownMenuStyle }}
        dropdownStyle={{ zIndex: props.zIndex }}
        defaultActiveFirstOption={false}>
        {data.map(d => <Option key={d.id} value={d.id} title={d.nome}>{`${!!d.codigo.length ? `${d.codigo} - ` : ""}${d.nome}`}</Option>)}
      </Select>

      {!!showAdd && <BtnAdd style={{ marginLeft: 10, width: 60 }} onClick={() => setIdCadastro(-1)} noLabel />}
    </div>

    <PesqEdit
      fetch={props.fetch}
      modelo={modelo}
      id={idCadastro}
      onCancel={() => setIdCadastro(null)}
      onOk={obj => saved(obj)}
    />
  </>;
});

export default connect(null, { fetch }, null, { forwardRef: true })(SelectPesq);

export function PesqEdit({ fetch, modelo, id, onCancel, onOk, jumpToEnderecos, isPk }) {
  const { setId, object, setObject, loading, save } = useCadastro(fetch, modelo, { onOk: onOk, disableListar: true }, isPk);

  useEffect(() => {
    if (id)
      setId({ id: id });

  }, [id]);

  return <FullScreenDialog
    visible={id}
    saving={loading}
    onCancel={() => {
      setObject(null);
      setId(null);
      onCancel();
    }}
    onOk={() => document.getElementById("btnFinalizarHide").click()}
    title="Cadastro"
  >
    {!!object && <ClienteDetalhe jump={jumpToEnderecos} cliente={!!object ? object : {}} setCliente={setObject} onOk={save} />}
  </FullScreenDialog>;
}
